/**
 * Publieke uitleg: prijsbibliotheek & meta (Fase 7 — gebruikershulp).
 */
import { Link } from 'react-router-dom';
import { AnimatedSection } from '../components/AnimatedSection';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { SeoMeta } from '../components/SeoMeta';

export function HelpLibrary() {
  return (
    <div className="animate-page-enter">
      <SeoMeta
        path="/help/bibliotheek"
        title="De prijsbibliotheek in CalqTool"
        description="CalqTool™ prijsbibliotheek: versies, posten en fair use. Documentenbibliotheek per dossier en koppeling met tekeninganalyse — zie ook hulp Tekening & PDF."
      />
      <AnimatedSection delay={0.05}>
        <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Bibliotheek' }]} />
        <h1 className="mb-4 text-2xl font-bold text-text">De prijsbibliotheek</h1>
        <p className="mb-8 max-w-2xl text-sm text-text-muted">
          CalqTool combineert jouw dossier met een <strong className="text-text">onderhouden prijsbibliotheek</strong>{' '}
          (systemen, varianten en referentiematerialen). Na inloggen zie je op tab <strong className="text-text">Posten</strong>{' '}
          o.a. het aantal actieve systemen en varianten in je tenant — dat helpt om te weten welke dataset je gebruikt.
        </p>

        <h2 className="mb-3 text-lg font-semibold text-text">Versie &amp; omvang</h2>
        <ul className="mb-8 max-w-2xl list-disc space-y-2 pl-5 text-sm text-text-muted">
          <li>
            De app toont <strong className="text-text">catalogusversie</strong> en totalen waar relevant (tooltip bij het
            prijsboek).
          </li>
          <li>
            Zoeken en filteren verkleint je resultaat — dat is bewust: je werkt met een subset die bij je project past.
          </li>
        </ul>

        <h2 className="mb-3 text-lg font-semibold text-text">Fair use</h2>
        <p className="mb-8 max-w-2xl text-sm text-text-muted">
          Calculatie, assistent en bibliotheek vallen onder <strong className="text-text">fair use</strong> en
          server-side rate limits. Bulk-export of automatisch uitlezen van de hele bibliotheek is niet toegestaan — zie
          ook de <Link to="/terms">algemene voorwaarden</Link>.
        </p>

        <h2 className="mb-3 text-lg font-semibold text-text">Documenten op je dossier</h2>
        <p className="mb-6 max-w-2xl text-sm text-text-muted">
          Deze pagina gaat over de <strong className="text-text">prijsbibliotheek</strong> (posten en materialen). Je{' '}
          <strong className="text-text">documentenbibliotheek</strong> (tekeningen/PDF per dossier) vind je na inloggen op
          tab <strong className="text-text">Gegevens</strong>: uploaden, openen, hernoemen (potlood) en onder{' '}
          <strong className="text-text">Tekening analyseren</strong> opnieuw aanvinken voor een run — zonder dubbele upload.
          Duidelijke bestandsnamen helpen de analyse; je kunt posten <strong className="text-text">in delen</strong>{' '}
          importeren terwijl de rest in de opgeslagen analyse blijft. Zie{' '}
          <Link to="/help/tekening" className="font-medium text-primary hover:underline">
            Tekening &amp; PDF
          </Link>
          .
        </p>

        <h2 className="mb-3 text-lg font-semibold text-text">Meer hulp</h2>
        <p className="mb-3 max-w-2xl text-sm text-text-muted">
          Voor storingen eerst{' '}
          <Link to="/status" className="font-medium text-primary hover:underline">
            dienststatus
          </Link>
          , daarna{' '}
          <Link to="/troubleshoot" className="font-medium text-primary hover:underline">
            problemen oplossen
          </Link>
          . Diepgaande uitleg:
        </p>
        <ul className="max-w-2xl list-disc space-y-2 pl-5 text-sm text-text-muted">
          <li>
            <Link to="/help/tekening" className="font-medium text-primary hover:underline">
              Tekening &amp; PDF
            </Link>
          </li>
          <li>
            <Link to="/help/export" className="font-medium text-primary hover:underline">
              Export &amp; offerte
            </Link>
          </li>
          <li>
            <Link to="/contact" className="font-medium text-primary hover:underline">
              Contact
            </Link>
          </li>
        </ul>
      </AnimatedSection>
    </div>
  );
}
